// JS shim to expose TS exports for legacy imports
const mod = require('./images');
module.exports = mod;
